export default __webpack_public_path__ + "static/media/photo--lg--48.f7326e53.jpg";